module.exports = __webpack_public_path__ + "img/yinyanghuoke-shuomingshu.2caf98b2.jpg";